import React from 'react';
import PropTypes from 'prop-types';
import Switch from './ui/Switch';
import RepeatGroup from './ui/RepeatGroup';

class BookingsModalQuestionnaire extends React.Component{

    render() {
        const questions = this.props.booking.questions;
        let questionRepeatGroups = [];
        if(questions){
            questionRepeatGroups = Object.keys(questions).map((question, index) => {
                if(questions[question] || questions[question] === "") {
                    return(
                        <RepeatGroup fieldName={"Question"} key={question} id={question} keyName={questions[question] || ''} value={null} onChange={(id, question) => this.props.updateQuestion('questions', id, question)} onRemove={(id)=> this.props.removeQuestion('questions', id)} type="textarea"/>
                    );
                }
                return null;
            });
        }

        return (
            <div className="tab-panel">
                <div className="column column-wide">
                    <Switch checked={this.props.booking.requireQuestions === "true"} label="Require the user to complete a questionnaire" onChange={checked => this.props.updateBooking("requireQuestions", checked) } />
                    { this.props.booking.requireQuestions === "true" ? questionRepeatGroups : null }
                    { this.props.booking.requireQuestions === "true" ? <a onClick={e => this.props.addQuestion('questions')} className="btn-add"><i className="material-icons">add_circle_outline</i>Add new</a> : null }
                </div>
            </div>
        );
    }
}

BookingsModalQuestionnaire.propTypes = {
    booking: PropTypes.object.isRequired,
    updateBooking: PropTypes.func.isRequired,
    addQuestion: PropTypes.func.isRequired,
    updateQuestion: PropTypes.func.isRequired,
    removeQuestion: PropTypes.func.isRequired
}

export default BookingsModalQuestionnaire;


/** WEBPACK FOOTER **
 ** ./src/components/BookingsModalQuestionnaire.js
 **/